<template>
    <v-container fluid grid-list-md>
<!--        <payment-methods v-if="stripeId"></payment-methods>-->
<!--        <account-payment-history></account-payment-history>-->
        <stripe-payment-histroy></stripe-payment-histroy>
    </v-container>
</template>

<script>
import StripePaymentHistroy from "@/pages/Billing/StripePaymentHistroy";
import {mapGetters} from "vuex";
export default {
    name: "Index",
    components: {StripePaymentHistroy},
    created() {
        this.$root.breadcrumbs = [
            {
                text: "Home",
                href: "/",
            },
            {
                text: "Biling",
                href: "/biling",
                icon: "../assets/arrow.svg",
            },
        ];
    },
    computed: {
        ...mapGetters("user", ["stripeId"])
    },
}
</script>

<style scoped>

</style>
